export const closeSubMenuMobile = () => {
    
    const init = component => {
        const handleClick = (event) => {
            const parent = component.parentElement.parentElement;

            if (parent && parent.classList.contains('nav-submenu__list--open')) {
                event.preventDefault();
                parent.classList.remove('nav-submenu__list--open');
                component.removeEventListener('click', handleClick);
            }
        };
        component.addEventListener('click', handleClick);
    };
    return {
        init: init,
        selector: '.nav-submenu__back-bar-link'
    };
};
